import type { ShopGameWallet } from '../types';

/** One wording for game-wallet sync states across the overview, provider tabs, drawer and Player detail. */
export const GAME_WALLET_SYNC_LABELS: Record<ShopGameWallet['syncStatus'], string> = {
  in_sync: 'In sync',
  pending: 'Pending',
  failed: 'Failed',
  never_synced: 'Never synced',
};
